import script from "./Page3.vue?vue&type=script&setup=true&lang=js"
export * from "./Page3.vue?vue&type=script&setup=true&lang=js"

import "./Page3.vue?vue&type=style&index=0&id=57e9b9e8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57e9b9e8"]])

export default __exports__